export function getScreenResolution() {
  const size = {
    width: window.screen.width,
    height: window.screen.height
  }

  const resolution = `${size.width},${size.height}`

  return resolution
}
